import { useEffect, useState } from "react";
// REDUX
import { useGetAllKeysLightQuery } from "../../redux/keys/keysAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";

/**
 * Fetches the key list via `useGetAllKeysLightQuery`.
 *
 * Resolves a JWT first and passes it to the query, which stays skipped until the
 * token arrives. Scoped to the globally selected organisation unless overridden.
 */
export default function useGetAllKeys() {
  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [keys, setKeys] = useState<any[]>([]);
  const [token, setToken] = useState<string | null>(null);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { data, isLoading, isFetching } = useGetAllKeysLightQuery(
    { token },
    { skip: !token, refetchOnMountOrArgChange: false },
  );

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    GETJwtToken().then(setToken);
  }, []);

  useEffect(() => {
    if (data && data.data) {
      setKeys(data.data);
    }
  }, [data]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return {
    keys,
    isLoadingGetAllKeys: isLoading || isFetching,
  };
}
